import { render, staticRenderFns } from "./VacancyKillerQuestions.vue?vue&type=template&id=230a674e&scoped=true"
import script from "./VacancyKillerQuestions.vue?vue&type=script&lang=js"
export * from "./VacancyKillerQuestions.vue?vue&type=script&lang=js"
import style0 from "./VacancyKillerQuestions.vue?vue&type=style&index=0&id=230a674e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a674e",
  null
  
)

export default component.exports